const thMessages = {
  /* 01.General */
   "main.name": "ชื่อ",
  "main.sentiment": "ความรู้สึก",
  "main.urgency": "ความเร่งด่วน",
  "main.language": "ภาษา",
  "main.agent": "เจ้าหน้าที่",
  "main.property_name": "ชื่อสถานที่",
  "main.booking_number": "หมายเลขการจอง",
  "main.check_out": "เช็คเอาท์",
  "main.check_in": "เช็คอิน",
  "main.adults": "ผู้ใหญ่",
  "main.corporate_code": "รหัสองค์กร",
  "main.group_code": "รหัสกลุ่ม",
  "main.promo_code": "รหัสโปรโมชั่น",
  "main.ai_response": "คำตอบ AI",
  "main.template_response": "คำตอบจากเทมเพลต",
  "main.converttoticket": "แปลงเป็นตั๋ว",
  "main.switch_property": "เปลี่ยนสถานที่",
  "main.Group_id": "รหัสกลุ่ม",
  "main.integration_id": "รหัสการผสานรวม",
  "main.submit": "ส่ง",
  "main.cancel": "ยกเลิก",
   "main.select_template": "เลือกเทมเพลต",
  "main.rooms": "ห้องพัก",
  "main.rates": "อัตราราคา",

  //footer
   "footer.knowledge": "ความรู้",
  "footer.home": "หน้าหลัก",
  "footer.help": "ช่วยเหลือ",

  //ticket
  "ticket.thank_you": "ขอบคุณสำหรับการส่งแบบฟอร์ม",
  "ticket.ticket": "ตั๋ว",
  "ticket.details": "กรุณากรอกแบบฟอร์มเพื่ออธิบายรายละเอียดของตั๋ว",
  "ticket.select_category": "เลือกหมวดหมู่",
  "ticket.category": "หมวดหมู่",
  "ticket.title": "หัวข้อ",
  "ticket.notes": "หมายเหตุ",
  "ticket.status": "สถานะ",
  "ticket.assigned_to": "มอบหมายให้",
  "ticket.submit_form": "ส่งแบบฟอร์ม",

  
  "main.total": "ทั้งหมด",
  "main.pastetooutlook": "วางลงใน Outlook",
  "main.children": "เด็ก",
  "main.promocode": "รหัสโปรโมชั่น/องค์กร/กลุ่ม",
  "main.exact_match_only": "ตรงกันเท่านั้น",
  "main.search": "ค้นหา",
  "main.no_rate_match": "ไม่มีราคาที่ตรงกับการเลือกของคุณ โปรดแก้ไขการค้นหาและลองอีกครั้ง",
  "main.translate_to": "แปลเป็น",
  "main.regenerate": "สร้างใหม่",
  "main.copy_text": "คัดลอกข้อความ",
  "main.additional_instructions": "คำแนะนำเพิ่มเติม",

  "faq.helpcenter": "ศูนย์ช่วยเหลือ",
  "faq.reply.email.sabre.question": "ฉันจะตอบอีเมลโดยใช้ Aven Hospitality Concierge Email Automation ได้อย่างไร?",
  "faq.reply.email.sabre.answer": "เปิดอีเมลและเปิดใช้งานส่วนเสริม Aven Hospitality คุณสามารถเลือกได้ 3 ตัวเลือก ได้แก่ ใช้เทมเพลตที่กำหนดไว้ สร้างคำตอบด้วย AI หรือแปลงอีเมลเป็นตั๋ว เลือกตัวเลือกที่เหมาะสม ตรวจสอบคำตอบ แก้ไขหากจำเป็น และส่งจาก Outlook โดยตรง",

  "faq.rates.availability.question": "ฉันจะเพิ่มราคา ความพร้อมใช้งาน และรายละเอียดห้องพักในคำตอบได้อย่างไร?",
  "faq.rates.availability.answer": "ใช้ฟีเจอร์ + Rates เพื่อกรอกข้อมูลผู้เข้าพัก เช่น วันที่และจำนวนผู้เข้าพัก Concierge จะเพิ่มราคาและข้อมูลห้องว่างที่ถูกต้องในคำตอบของคุณ",

  "faq.different.language.question": "ฉันควรทำอย่างไรหากอีเมลเป็นภาษาอื่น?",
  "faq.different.language.answer": "Aven Hospitality Concierge สามารถแปลอีเมลขาเข้าเป็นภาษาที่คุณต้องการได้",

  "faq.pin.addin.question": "ฉันจะทำให้ส่วนเสริมพร้อมใช้งานใน Outlook ตลอดเวลาได้อย่างไร?",
  "faq.pin.addin.answer": "ปักหมุดส่วนเสริม Aven Hospitality Concierge ใน Outlook เพื่อให้แสดงอยู่เสมอ",

  "faq.knowledge.hub.question": "ตัวเลือกค้นหา Knowledge Hub คืออะไร?",
  "faq.knowledge.hub.answer": "การค้นหา Knowledge Hub ช่วยให้ค้นหาข้อมูลเฉพาะของที่พักได้อย่างรวดเร็วใน Outlook",

  "faq.reply.email.myma.question": "ฉันจะตอบอีเมลโดยใช้ Myma ได้อย่างไร?",
  "faq.reply.email.myma.answer": "เปิดอีเมลและเปิดส่วนเสริม Myma สามารถใช้เทมเพลต สร้างคำตอบ AI หรือแปลงเป็นตั๋วได้",

  "faq.room.details.question": "ฉันจะเพิ่มรายละเอียดห้องพักในคำตอบได้อย่างไร?",
  "faq.room.details.answer": "ใช้ + Rooms เพื่อเพิ่มคำอธิบายห้องพักและรูปภาพ",

  "faq.myma.different.language.question": "ฉันควรทำอย่างไรหากอีเมลเป็นภาษาอื่น?",
  "faq.myma.different.language.answer": "Myma ช่วยให้คุณแปลอีเมลขาเข้าเป็นภาษาที่ต้องการได้",

  "faq.myma.pin.addin.question": "ฉันจะทำให้ส่วนเสริมพร้อมใช้งานใน Outlook ตลอดเวลาได้อย่างไร?",
  "faq.myma.pin.addin.answer": "ปักหมุดส่วนเสริม Myma ใน Outlook เพื่อให้เปิดอัตโนมัติเมื่อมีอีเมลใหม่",

};
export default thMessages;